import { useContext } from "react";
import { Box, Button, Paper, Typography, useMediaQuery } from "@mui/material";
import PermissionMatrixContext from "@/Contexts/PermissionMatrix/Context";

const ChangeDetectedPrompt = () => {
  const { isDirty, resetDraft, saveDraft, saving } = useContext(PermissionMatrixContext);
  const isSm = useMediaQuery("(max-width: 900px)");

  if (!isDirty) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 18,
        display: "flex",
        justifyContent: "center",
        zIndex: 1300,
        px: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: "min(920px, 100%)",
          p: 2,
          display: "flex",
          alignItems: "center",
          gap: 2,
          borderRadius: 1,
        }}
      >
        <Typography variant={isSm ? "body1" : "h6"} sx={{ flex: 1 }}>
          Careful — You have unsaved changes
        </Typography>

        <Button
          color="error"
          variant="text"
          onClick={resetDraft}
          disabled={saving}
          sx={{ fontWeight: 700 }}
        >
          RESET
        </Button>

        <Button
          color="success"
          variant="contained"
          onClick={saveDraft}
          disabled={saving}
          sx={{ fontWeight: 800, px: 3 }}
        >
          {saving ? "SAVING…" : "SAVE CHANGES"}
        </Button>
      </Paper>
    </Box>
  );
};

export default ChangeDetectedPrompt;
